/**
 * Route Constants
 * Centralized route paths for navigation and routing
 * 
 * Usage:
 * import { ROUTES } from 'shared/constants';
 * navigate(ROUTES.DASHBOARD);
 */

export const ROUTES = {
  // Auth
  LOGIN: '/login',
  
  // Main
  DASHBOARD: '/',
  DIVISION_GROUP: '/division-group',
  
  // Tour & Planning
  MONTHLY_TOUR_PLAN: '/monthly-tour-plan',
  CURRENT_DAY_TOUR: '/current-day-tour',
  MARKET_VISIT_REPORT: '/market-visit-report',
  TOUR_REPORT: '/tour-report',
  
  // Dealer
  MY_DEALER: '/my-dealer',
  DEALER_LOCATOR: '/dealer-locator',
  EXCEPTION_DEALER: '/exception-dealer',
  
  // Team
  MY_TEAM: '/my-team',
  MY_USER: '/my-user',
  MY_PROFILE: '/my-profile',
  MY_WSS: '/my-wss',
  
  // DRM
  DRM_PLANNING: '/DRMplanning',
  DRM_SUMMARY: '/DRM-Summary',
  DRM_FEEDBACK_FORM: '/DRMfeedbackForm',
  DRM_DETAILS: (id) => `/drm-details/${id}`,
  DRM_MEETING_APPROVAL: '/drm-meeting-approval',
  DRM_MEETING: '/drm-meeting',
  DRM_MEETING_LIST: '/drm-planning',
  
  // Market Working
  MY_DIARY: '/my-diary',
  MARKET_WORKING: '/market-working',
  TOTAL_FEEDBACK: '/total-feedback',
  PAST_SR_INSIGHT: '/past-sr-insight',
  
  // Key Information & Reports
  KEY_INFORMATION: '/key-information',
  QUERIES: '/queries',
  QUERY_DETAILS: (id) => `/query-details/${id}`,
  
  // Power BI & Analytics
  POWER_BI: '/power-bi',
  PBI_DASHBOARD: '/pbi-dashboard',
  BRANCH_PERFORMANCE_INDEX: '/branch-performance-index',
  TSI_MARKET_WORKING: '/tsi-market-working',
  DISTRIBUTOR_INVOICING: '/distributor-invoicing',
  KEY_DEALER_PERFORMANCE: '/key-dealer-performance',
  PIL_SIMILAR_SURVEY: '/pil-similar-survey',
  
  // Survey & Forms
  SURVEY: '/survey',
  PIL_SURVEYS: '/pil-Surveys',
  LCD_FORM: '/lcdform',
  CWP: '/cwp',
  
  // PCMS
  PCMS: (id) => id ? `/PCMS/${id}` : '/PCMS',
  
  // Other
  BOTTOM_NAVBAR: '/bottom-navbar',
};

/**
 * Check if current path matches route
 * @param {string} path - Current pathname
 * @param {string} route - Route to check
 * @returns {boolean}
 */
export const isActiveRoute = (path, route) => {
  if (typeof route === 'function') {
    // Dynamic routes - check if path starts with base
    const baseRoute = route('').replace(/\/$/, '');
    return path.startsWith(baseRoute);
  }
  return path === route;
};

/**
 * Get route with params
 * @param {string|function} route - Route constant
 * @param {object} params - Route parameters
 * @returns {string}
 */
export const getRoute = (route, params = {}) => {
  if (typeof route === 'function') {
    return route(params.id || params);
  }
  return route;
};

export default ROUTES;
